import { FormField } from 'grommet';
import styled from 'styled-components';

export const BorderlessFormField = styled(FormField)`
  all: unset;
  div:first-child {
    border: unset;
  }
`;
